import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { Url } from '@wix/da-url';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Avatar from '../../../User/Avatar';
import UserLink from '../../../User/Link/UserLink';
import s from './AdoptableOwner.scss';
const AdoptableOwner = ({ adoptable , className  })=>{
    const { t  } = useTranslation();
    // Don't show indicator if the adoptable is still owned by the creator of the deviation
    if (adoptable.owner.userId === adoptable.creator.userId) {
        return null;
    }
    const content = /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, /*#__PURE__*/ React.createElement(Avatar, {
        user: adoptable.owner,
        size: 24
    }), /*#__PURE__*/ React.createElement("div", null, t('deviation.details.adopted'), ' ', /*#__PURE__*/ React.createElement(UserLink, {
        className: s['owner-userlink'],
        user: adoptable.owner
    })));
    if (adoptable.isCreator || adoptable.isOwner) {
        const tooltipText = /*#__PURE__*/ React.createElement(React.Fragment, null, t(adoptable.isCreator ? 'deviation.details.adopted.tooltip.creator' : 'deviation.details.adopted.tooltip.owner'), adoptable.isOwner && adoptable.deviationId && /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
            className: s['download-link'],
            href: Url.adoptableSourceFileLink(adoptable.deviationId)
        }, t('deviation.details.adopted.tooltip.downloadLink')));
        return /*#__PURE__*/ React.createElement(SimpleTooltip, {
            text: tooltipText,
            prefix: /*#__PURE__*/ React.createElement(CheckIcon, {
                size: IconSize.SMALL
            }),
            contentClassName: s['tooltip']
        }, content);
    }
    return content;
};
AdoptableOwner.displayName = 'AdoptableOwner';
export default AdoptableOwner;
